import React from "react"
import styled from "styled-components"
import {
    RadioCheckedIcon,
    RadioUncheckedIcon,
    CheckedIcon,
    UncheckedIcon,
    SpinnerIcon,
} from "client/components"

const RadioButtonWrapper = styled.div<{
    checked: boolean
    readOnly: boolean
    padding: boolean
    margin: boolean
    type: "radio" | "check"
}>`
    display: flex;
    flex-direction: row;
    width: fit-content;
    align-items: center;
    margin-bottom: ${(props) => (props.margin ? "3px" : "0")};
    padding-left: ${(props) => (props.padding ? "20px" : "0")};
    cursor: pointer;

    & > i {
        width: 20px;
        text-align: center;
        font-size: ${(props) => {
        if (props.type === "radio") return "14px"
        if (props.type === "check") return "15px"
        return "14px"
    }};
        color: ${(props) => (props.checked ? props.theme.radioButtonActiveColor : props.theme.radioButtonInactiveColor)};
        opacity: ${(props) => (props.readOnly ? 0.7 : 1)};
    }

    & > .fa-spinner {
        height: 20px;
        font-size: 20px;
        color: ${(props) => props.theme.radioButtonSpinnerColor};
    }
`
const RadioButtonTitle = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 10px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: ${(props) => props.theme.fontSizes.xs}px;
    font-family: ${(props) => props.theme.openSans};

    input {
        margin-right: 5px;
        margin-bottom: 0;
        font-size: ${(props) => props.theme.fontSizes.md}px;
    }
`

interface RadioProps {
    title?: any
    checked: boolean
    readOnly?: boolean
    isLoading?: boolean
    padding?: boolean
    margin?: boolean
    onChange?: () => void
}

export const RadioButton = ({
    title,
    checked,
    readOnly = false,
    isLoading = false,
    padding = true,
    margin = true,
    onChange = null,
}: RadioProps) => (
    <RadioButtonWrapper
        checked={checked}
        readOnly={readOnly}
        padding={padding}
        margin={margin}
        type="radio"
        onClick={readOnly ? null : onChange}
    >
        {
            isLoading
            && <SpinnerIcon />
        }
        {
            !isLoading && (
                checked ? <RadioCheckedIcon /> : <RadioUncheckedIcon />
            )
        }
        {
            title
            && <RadioButtonTitle>{title}</RadioButtonTitle>
        }
    </RadioButtonWrapper>
)

export const CheckButton = ({
    title,
    checked,
    readOnly = false,
    isLoading = false,
    padding = true,
    margin = true,
    onChange = null,
}: RadioProps) => (
    <RadioButtonWrapper
        checked={checked}
        readOnly={readOnly}
        padding={padding}
        margin={margin}
        type="check"
        onClick={readOnly ? null : onChange}
    >
        {
            isLoading
            && <SpinnerIcon />
        }
        {
            !isLoading && (
                checked ? <CheckedIcon /> : <UncheckedIcon />
            )
        }
        {
            title
            && <RadioButtonTitle>{title}</RadioButtonTitle>
        }
    </RadioButtonWrapper>
)
